import { httpClient } from "../http-client";

export async function fetchWecomaAuthKey(clientId: string): Promise<string> {
    const response = await httpClient.post<string>("/kasa/gdpr/auth-key", {
        purpose: "uid",
        value: clientId,
    });

    return response.data;
}
